import lang from "@/views/modules/ReviewerDocuments/language/en";

export default {
    name: "new-example",
    components: {
    },
    data() {
        return {
            loading: true,
            example: {},
            lang:[],
        }
    },
    mounted() {
        this.getBudgethead();
        this.lang = lang;
    },
    methods: {
        saveBudgethead() {
            const self = this;
            self.loading = true;
            axios.post('api/modules/reviewerdocuments', self.example).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/reviewerdocuments/' + response.data.example.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}